export default "__VITE_ASSET__Cu312yS4__"